import React, { Component } from 'react';
import { Card, CardBody, CardHeader, Button, CardTitle, CardText } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import { injectIntl, intlShape } from 'react-intl';
import Dropzone from 'react-dropzone';
import Duplicates from './Duplicates';

class PersonalData extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	// ${ requirements.name.required ? ' isRequired' : ''}

	render() {
		const { colors, requirements, modules } = this.props.settings;
		const { images, description, firstName, lastName, email, phone } = this.props.formProps;
		let dropzoneRef;
		return (
			<div className="row">
				<div className={modules.reportDuplicates ? 'col-lg-8 col-md-12' : 'col-lg-12 col-md-12'}>
					<Card>
						<CardHeader className="custom-main">
							<IntlMessages id="meldooWeb.newReport.personalData.title" />
						</CardHeader>
						<CardBody>
							<div className="row">
								{requirements.description.show && (
									<div className="col-md-6 col-sm-6 col-12">
										<CardText>
											<IntlMessages id="meldooWeb.newReport.description.info" />
										</CardText>
										<div className="form-group">
											<label>
												<strong>
													<IntlMessages id="meldooWeb.newReport.description.title" />
													{requirements.description.required && <span style={{ color: colors.accent.font }}>(*)</span>}
												</strong>
											</label>
											<textarea
												className={`form-control form-control-lg my-3 ${
													this.props.errorMessages.description ? 'is-invalid' : ''
												}`}
												rows="3"
												placeholder={this.props.intl.formatMessage({
													id: 'newReport.description'
												})}
												onChange={m => this.props.onUpdateFormProp('description', m.target.value)}
												value={description}
											/>
											<div className="invalid-feedback">
												<IntlMessages id="meldooWeb.newReport.errors.description" />
											</div>
										</div>
									</div>
								)}
								<div className="col-md-6 col-sm-6 col-12">
									<CardText>
										<IntlMessages id="meldooWeb.newReport.reportImage.info" />
									</CardText>
									<div className="d-flex justify-content-start">
										<div className="dropzone">
											<Dropzone
												ref={node => {
													dropzoneRef = node;
												}}
												onDrop={(accepted, rejected) => {
													if (accepted.length === 0) {
														return;
													} else {
														if (accepted.length + images.length > 4) {
															while (accepted.length + images.length > 4) {
																accepted.pop();
															}
														}
														this.props.onUpdateFormProp('images', [...images, ...accepted]);
													}
												}}
												multiple={true}
												disableClick={true}
												minSize={0}
												maxSize={5242880}
											>
												{images.length === 0 ? (
													<div
														className="w-100 h-100 d-flex align-items-center flex-column"
														style={{
															justifyContent: 'space-evenly'
														}}
													>
														<i
															className="zmdi zmdi-collection-image-o zmdi-hc"
															style={{
																fontSize: '5em'
															}}
														/>
														<p className="pt-2 text-center">
															<IntlMessages id="userProfile.profileImage.dropImage" />
														</p>
													</div>
												) : (
													<div className="gl-image w-100 h-100">
														<div className="gl row no-gutters g-ul w-100">
															{images.map((image, index) => (
																<div key={index} className="col-6">
																	<div
																		className="grid w-100"
																		style={{
																			height: 79,
																			backgroundImage: `url(${image.preview})`,
																			backgroundSize: 'cover',
																			backgroundRepeat: 'no-repeat',
																			backgroundPosition: 'center'
																		}}
																	/>
																	<div className="diagonal-box" />
																	<div
																		className="image-remove-icon d-flex align-items-end justify-content-end pointer"
																		onClick={() =>
																			this.props.onUpdateFormProp(
																				'images',
																				images.filter((image, index2) => index !== index2)
																			)
																		}
																	>
																		<i className="zmdi zmdi-close zmdi-hc-2x" />
																	</div>
																</div>
															))}
															{images.length < 4 ? (
																<div className="col-6">
																	<div
																		className="grid w-100 d-flex align-items-center justify-content-center"
																		style={{
																			height: 79,
																			backgroundColor: '#f4f4f4'
																		}}
																		onClick={() => {
																			dropzoneRef.open();
																		}}
																	>
																		<i className="zmdi zmdi-plus zmdi-hc-2x" />
																	</div>
																</div>
															) : null}
														</div>
													</div>
												)}
											</Dropzone>
											<p className="text-muted text-center m-2">
												<IntlMessages id="common.or" />
											</p>
											<div className="d-flex flex-direction-column align-items-center px-3 py-0">
												<Button
													color="default"
													className="jr-btn btn-grey btn border-0 mt-0 mb-2 mx-0"
													onClick={() => {
														dropzoneRef.open();
													}}
													disabled={images.length > 3}
													style={{ width: 200, textTransform: 'none' }}
												>
													<IntlMessages id="userProfile.profileImage.selectImage" />
												</Button>
											</div>
										</div>
									</div>
								</div>
								<div className="col-12">
									<CardTitle>
										<IntlMessages id="meldooWeb.newReport.contactInformation.title" />
									</CardTitle>
									<div className="row">
										{requirements.name.show && (
											<div className="col-sm-6 col-12">
												<div className="form-group">
													<label>
														<strong>
															<IntlMessages id="common.name" />
															{requirements.name.required && <span style={{ color: colors.accent.font }}>(*)</span>}
														</strong>
													</label>
													<input
														className={`form-control form-control-lg ${
															this.props.errorMessages.firstName ? 'is-invalid' : ''
														}`}
														name="given-name"
														value={firstName}
														onChange={m => this.props.onUpdateFormProp('firstName', m.target.value)}
														type="text"
														placeholder={this.props.intl.formatMessage({
															id: 'common.firstName'
														})}
													/>
													<div className="invalid-feedback">
														<IntlMessages id="meldooWeb.newReport.errors.firstName" />
													</div>
												</div>
											</div>
										)}
										{requirements.name.show && (
											<div className="col-sm-6 col-12">
												<div className="form-group">
													<label>
														&nbsp;
														<strong>
															{requirements.name.required && <span style={{ color: colors.accent.font }}>(*)</span>}
														</strong>
													</label>
													<input
														className={`form-control form-control-lg ${
															this.props.errorMessages.lastName ? 'is-invalid' : ''
														}`}
														name="family-name"
														value={lastName}
														onChange={m => this.props.onUpdateFormProp('lastName', m.target.value)}
														type="text"
														placeholder={this.props.intl.formatMessage({
															id: 'common.lastName'
														})}
													/>
													<div className="invalid-feedback">
														<IntlMessages id="meldooWeb.newReport.errors.lastName" />
													</div>
												</div>
											</div>
										)}

										{requirements.email.show && (
											<div className="col-sm-6 col-12">
												<div className="form-group">
													<label>
														<strong>
															<IntlMessages id="common.email" />
															{requirements.email.required && <span style={{ color: colors.accent.font }}>(*)</span>}
														</strong>
													</label>
													<input
														className={`form-control form-control-lg ${
															this.props.errorMessages.email ? 'is-invalid' : ''
														}`}
														name="email"
														value={email}
														onChange={m => this.props.onUpdateFormProp('email', m.target.value)}
														type="email"
														placeholder={this.props.intl.formatMessage({
															id: 'common.email'
														})}
													/>
													<div className="invalid-feedback">
														<IntlMessages id="meldooWeb.newReport.errors.email" />
													</div>
												</div>
											</div>
										)}

										{requirements.phone.show && (
											<div className="col-sm-6 col-12">
												<div className="form-group">
													<label>
														<strong>
															<IntlMessages id="common.phone" />
															{requirements.phone.required && <span style={{ color: colors.accent.font }}>(*)</span>}
														</strong>
													</label>
													<input
														className={`form-control form-control-lg ${
															this.props.errorMessages.phone ? 'is-invalid' : ''
														}`}
														name="tel"
														value={phone}
														onChange={m => this.props.onUpdateFormProp('phone', m.target.value)}
														type="tel"
														placeholder={this.props.intl.formatMessage({
															id: 'common.phone'
														})}
													/>
													<div className="invalid-feedback">
														<IntlMessages id="meldooWeb.newReport.errors.phone" />
													</div>
												</div>
											</div>
										)}
									</div>
								</div>
								<div className="col-12">
									<strong>
										<span style={{ color: colors.accent.font }}>(*)</span> Pflichtfelder
									</strong>
								</div>
							</div>
						</CardBody>
					</Card>
					<div className="d-flex w-100 justify-content-between">
						<Button color="default" className="jr-btn jr-btn-default custom-previous" onClick={this.props.onPreviousStep}>
							<i className="zmdi zmdi-chevron-left zmdi-hc-lg" />
							<IntlMessages id="meldooWeb.newReport.previousStep" />
						</Button>
						<Button color="default" className="jr-btn jr-btn-default custom-next" onClick={this.props.onNextStep}>
							<IntlMessages id="meldooWeb.newReport.nextStep" />
							<i className="zmdi zmdi-chevron-right zmdi-hc-lg" />
						</Button>
					</div>
				</div>
				{modules.reportDuplicates && (
					<div className="col-lg-4 col-md-12">
						<Duplicates duplicates={this.props.duplicates} colors={colors} toReport={this.props.toReport} />
					</div>
				)}
			</div>
		);
	}
}

PersonalData.propTypes = {
	intl: intlShape.isRequired
};

export default injectIntl(PersonalData);



// WEBPACK FOOTER //
// ./containers/MeldooWeb/Pages/NewReport/Component/PersonalData.js